import React, { useEffect, useState } from "react";
import "./contactModal.css";
import f1 from "../../assets/images/home/india-flag-1.png";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { IoArrowBack } from "react-icons/io5";
import { Link } from "react-router-dom";

import { EMAIL_ADDRESS, MOBILE_NUMBER } from "../../Constant/Global";
import { parsePhoneNumberFromString } from "libphonenumber-js";

const ContactModal = ({ isOpen, onClose }) => {
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [nameError, setNameError] = useState("");
  const [step, setStep] = useState(1); // 1 = phone, 2 = name
  const [loading, setLoading] = useState(false);
  const [country, setCountry] = useState("");

  useEffect(() => {
    if (isOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "auto";
  }, [isOpen]);

  if (!isOpen) return null;

  const handlePhoneNext = (e) => {
    e.preventDefault();

    if (!phone || phone.trim() === "") {
      setPhoneError("Please enter your phone number");
      return;
    }

    try {
      const phoneNumber = parsePhoneNumberFromString(phone);

      // Invalid number for selected country
      if (!phoneNumber || !phoneNumber.isValid()) {
        setPhoneError(`Please enter a valid phone number`);
        return;
      }

      setPhoneError("");
      setStep(2);
    } catch (error) {
      setPhoneError("Invalid phone number format");
    }
  };

  const handleBackToPhone = () => {
    setStep(1);
    setNameError("");
  };

  //by email
  const handleFinalSubmit = (e) => {
    e.preventDefault();

    if (!name.trim()) {
      setNameError("Please enter your name");
      return;
    }

    setNameError("");

    // Receiver email
    const emailTo = { EMAIL_ADDRESS }; // CHANGE THIS

    const subject = "New Call Back Request 📞";

    const body = `
📞 New Call Back Request

Hello Team,

You have received a new call back request. Please find the details below:

----------------------------------
Name  : ${name}
Phone : ${phone}
Country : ${country}
----------------------------------

Please contact the user at your earliest convenience.

Thank you.
`;

    // Encode for URL
    const mailtoLink = `mailto:${emailTo}?subject=${encodeURIComponent(
      subject,
    )}&body=${encodeURIComponent(body)}`;

    // Open email client
    window.location.href = mailtoLink;

    // Reset & close
    setPhone("");
    setName("");
    setStep(1);
    onClose();
  };

  return (
    <div className="contactModalOverlay" onClick={onClose}>
      <div
        className="contactModalContainer"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="contactModalClose" onClick={onClose}>
          ✕
        </button>

        <h2>Leaving so soon?</h2>
        <p className="subtitle">Tell us what you were looking for!</p>

        <p className="smallText">Share your number to get a call-back.</p>

        {/* STEP 1 – PHONE */}
        {step === 1 && (
          <form onSubmit={handlePhoneNext}>
            <div className="phoneRow">
              <div className="phoneRow-1">
                <PhoneInput
                  defaultCountry="in"
                  value={phone}
                  onChange={(value, meta) => {
                    setPhone(value);
                    setCountry(meta?.country?.name || "");
                    setPhoneError("");
                  }}
                  className="phoneInput"
                  placeholder="98778965432"
                />
              </div>

              <button className="callbackBtn">📞 Call me back</button>
            </div>

            {phoneError && <p className="phoneError">{phoneError}</p>}
          </form>
        )}

        {/* STEP 2 – NAME */}

        {step === 2 && (
          <>
            <button
              type="button"
              className="callbackBtn-2"
              onClick={handleBackToPhone}
            >
              <IoArrowBack /> Back
            </button>
            <form onSubmit={handleFinalSubmit}>
              <div className="phoneRow">
                <div className="phoneRow-2">
                  <input
                    type="text"
                    placeholder="Enter your name"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                      setNameError("");
                    }}
                  />
                </div>

                <button className="callbackBtn" disabled={loading}>
                  {loading ? "Sending..." : "Submit"}
                </button>
              </div>

              {nameError && <p className="phoneError">{nameError}</p>}
            </form>
          </>
        )}

        <p className="secureText">
          Rest assured, your details are secure with us.
        </p>

        <div className="links">
          <p>
            Have a custom requirement?{" "}
            <Link to={`mailto:${EMAIL_ADDRESS}`}>Write to us</Link>
          </p>
          <p>
            In a hurry?{" "}
            <Link to={`tel:${MOBILE_NUMBER}`}>Call us now {MOBILE_NUMBER}</Link>
          </p>
        </div>

        <p className="note">
          *Please keep 0 or +91 before the number you dial.
        </p>
      </div>
    </div>
  );
};

export default ContactModal;
